import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { Milestone, CreateMilestone, UpdateMilestone } from '#models';

@Injectable({ providedIn: 'root' })
export class MilestoneService {
    private _http = inject(HttpClient);
    private _base = `${environment.apiBaseUrl}/v1/remediations`;

    getByRemediation(remediationId: string): Observable<Milestone[]> {
        return this._http.get<Milestone[]>(`${this._base}/${remediationId}/milestones`);
    }

    create(remediationId: string, dto: CreateMilestone): Observable<Milestone> {
        return this._http.post<Milestone>(`${this._base}/${remediationId}/milestones`, dto);
    }

    update(remediationId: string, milestoneId: string, dto: UpdateMilestone): Observable<Milestone> {
        return this._http.put<Milestone>(`${this._base}/${remediationId}/milestones/${milestoneId}`, dto);
    }

    markComplete(remediationId: string, milestoneId: string): Observable<Milestone> {
        return this._http.patch<Milestone>(
            `${this._base}/${remediationId}/milestones/${milestoneId}/complete`,
            {}
        );
    }

    delete(remediationId: string, milestoneId: string): Observable<void> {
        return this._http.delete<void>(`${this._base}/${remediationId}/milestones/${milestoneId}`);
    }
}
